var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { premiumCalculatePost } from "../../../store/premiumCalculate/actions";
export var usePremiumCalculate = function (productCode, planCode, birthDate, gender) {
    var dispatch = useDispatch();
    var birthDateRef = useRef(birthDate);
    var genderRef = useRef(gender);
    var lastBody = useRef(null);
    birthDateRef.current = birthDate;
    genderRef.current = gender;
    var _a = useSelector(function (state) { return ({
        loadingCalculate: state.PremiumCalculate.loadingCalculate,
        responseCalculate: state.PremiumCalculate.responseCalculate,
        errorCalculate: state.PremiumCalculate.errorCalculate,
    }); }), loadingCalculate = _a.loadingCalculate, responseCalculate = _a.responseCalculate, errorCalculate = _a.errorCalculate;
    var calculatePremium = useCallback(function (coverageAmount, paymentMode, paymentModeId, numberCard) {
        var resolvedPlanCode = (planCode === null || planCode === void 0 ? void 0 : planCode.includes("/"))
            ? planCode.split("/")[1]
            : planCode;
        var body = {
            productCode: productCode,
            planCode: resolvedPlanCode,
            inputData: {
                birthDate: birthDateRef.current,
                gender: genderRef.current,
                smokes: false,
                coverageAmount: Number(coverageAmount),
                paymentMode: paymentMode,
            },
        };
        lastBody.current = __assign({ productCode: body.productCode, numberCard: numberCard, planCode: body.planCode, catalogPaymentMode: paymentModeId }, body.inputData);
        dispatch(premiumCalculatePost(body));
    }, [dispatch, productCode, planCode]);
    return {
        responseCalculate: responseCalculate,
        loadingCalculate: loadingCalculate,
        errorCalculate: errorCalculate,
        calculatePremium: calculatePremium,
        lastBody: lastBody,
    };
};
